import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

export interface SessionExpiredDialogData {
  redirectUrl: string;
}

@Component({
  selector: 'core-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html',
  styleUrls: ['./session-expired-dialog.component.scss'],
  imports: [
    MatIcon,
    MatDialogContent,
    MatDialogClose,
    MatButton,
    MatMiniFabButton,
    RouterLink,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionExpiredDialogComponent {
  protected readonly data = inject<SessionExpiredDialogData>(MAT_DIALOG_DATA);
}
